import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import backgroundImage from '../../assets/img/fondoTres.png';
import logoCIE from '../../assets/img/logoCIE.svg';
import useLogout from '../../hooks/useLogout';
import Lottie from 'react-lottie';
import confettiAnimation from '../../assets/Confetti.json';
import trofeoAnimation from '../../assets/Trofeo.json';
import HeaderUsuario from '../header/HeaderUsuario';
import GenerarCertificado from './GenerarCertificado';
import useTrofeoUsuario from '../../hooks/useTrofeoUsuario';


const TrofeoUsuario = () => {
    // Hook personalizado para obtener el resumen del trofeo del usuario
    const { resumen, loading, error } = useTrofeoUsuario();

    // Configuración para la animación de confeti
    const confettiOptions = {
        loop: true,
        autoplay: true,
        animationData: confettiAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    // Configuración para la animación del trofeo
    const trofeoOptions = {
        loop: true,
        autoplay: true,
        animationData: trofeoAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
        
    };

    function formatTiempo(segundos) {
        const horas = Math.floor(segundos / 3600);
        const minutos = Math.floor((segundos % 3600) / 60);
        const segs = segundos % 60;

        return [
            horas.toString().padStart(2, '0'),
            minutos.toString().padStart(2, '0'),
            segs.toString().padStart(2, '0')
        ].join(':');
    }

    // Componente principal que renderiza la página de trofeo del usuario
    return (
        <div className="min-h-screen flex flex-col font-montserrat relative"
            style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
            {/* Header del usuario */}
            <div className="absolute top-1.5 right-2 z-40 sm:z-50">
                <HeaderUsuario />
            </div>

            {/* Contenido principal */}
            <div className="flex-grow flex scale-90 justify-center items-center my-10 rounded-lg p-4 absolute inset-0  px-4">
                <div className="bg-white rounded-lg p-5 max-w-2xl w-full relative shadow-[0_9px_20px_rgba(0,0,0,0.8)]">
            
                    <h2 className="text-5xl font-montserrat font-extrabold mb-6 text-green-700 text-center">¡Felicidades!</h2>

                    <div className="relative">
                        
                        {/* Animación de confeti */}
                        <div className="absolute top-0 left-0 right-0 bottom-0 z-10">
                            <Lottie options={confettiOptions} height={400} width={400} />
                        </div>
                        <div className="flex flex-col items-center justify-center z-20 relative">
                            {/* Animación del trofeo */}
                            <Lottie options={trofeoOptions} height={300} width={300} />

                            {/* Manejo de estados de carga y error */}
                            {loading && <p className="text-center">Cargando resumen...</p>}
                            {error && <p className="text-center text-red-500">{error}</p>}
                            {resumen && (
                                <div>
                                    <p className="text-center text-4xl font-bold mb-4 text-green-700 ">{resumen.total_correctas} Estrellas</p>
                                    <p className="text-center text-4xl font-bold mb-4 text-yellow-500 ">{resumen.total_incorrectas} Repetidas</p>
                                    <div className="flex justify-center">
                                        <GenerarCertificado nombreUsuario={resumen.nombre_usuario} />
                                    </div>

                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Logo CIE */}
            <div className="absolute bottom-4 right-4 z-10">
                <img src={logoCIE} alt="Logo CIE" className="h-10 w-auto" />
            </div>
        </div>
    );
};

export default TrofeoUsuario;